<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div class="modalContent">
        <div class="tree"></div>
        <div class="close" v-on:click="close"></div>
        <div class="itemImg"
          :style="{'background-image': `url(${imgUri})`}"></div>
        <div class="itemInfo" :class="{joined: d.joined}">
          <div class="timestamp" v-if="d.joined">
            <s>{{d.challengeDate | moment('dddd')}}</s>
            <div class="missionJoined">Misi Diikuti</div>
          </div>
          <h4>{{d.name}}</h4>
          <p v-if="d && d.description" v-html="d.description"></p>
          <div v-if="!d.joined">
            <button :class="{btnLoading: loading}" v-on:click="joinNow" v-if="canJoin">
              <span>Team Up Now</span>
            </button>
            <button class="cantJoin" v-else>
              Ikuti misi ini besok
            </button>
          </div>
          <div class="itemAction" v-if="d.joined">
            <h4>Share di socmed, yuk!</h4>
            <div class="selectorCnt">
              <a :href="`https://www.facebook.com/sharer/sharer.php?u=${shareEncoded}`"
                target="_blank" class="selectorItem"
                v-on:click="recordShare">
                <img src="../assets/i-facebook-2.png">
                <h4>Facebook</h4>
              </a>
              <a :href="`https://twitter.com/intent/tweet?url=${shareEncoded}&text=${escapedTitle}&related=Amway,Boydkey,Nutrilite,BkChallenge2022`"
                target="_blank" class="selectorItem"
                v-on:click="recordShare">
                <img src="../assets/i-twitter-2.png">
                <h4>Tweet</h4>
              </a>
              <div class="selectorItem" v-on:click="openIg">
                <img src="../assets/i-instagram.png">
                <h4>Instagram</h4>
              </div>
              <a :href="`https://api.whatsapp.com/send/?phone&text=${waText}&app_absent=0`"
                target="_blank" class="selectorItem"
                v-on:click="recordShare">
                <img src="../assets/i-wa.png">
                <h4>Whatsapp</h4>
              </a>
              <a :href="imgUri" download target="_blank" class="selectorItem"
                v-on:click="recordShare">
                <img src="../assets/download-o.png">
                <h4>Download</h4>
              </a>
            </div>
          </div>
        </div>
      </div>
      <ShareDialog ref="shareDialog"/>
      <IgDialog ref="igDialog"/>
      <DownloadChooser ref="downloadChooser"/>
    </div>
  </transition>
</template>

<script>
import ShareDialog from '@/components/ShareDialog.vue';
import IgDialog from '@/components/IgDialog.vue';
import DownloadChooser from '@/components/DownloadChooser.vue';

export default {
  name: 'confirmation',
  components: { ShareDialog, IgDialog, DownloadChooser },
  data() {
    return {
      show: false,
      next: null,
      imgUri: '',
      loading: true,
      d: null,
      canJoin: true,

      /**
       * Share
       *
       */
      shareUriDisplay: '',
      shareEncoded: '',
      escapedTitle: '',
      waText: '',
      storyUri: '',
    };
  },
  methods: {
    open(d, next) {
      const dt = new Date();
      const cd = new Date(d.d.challengeDate);
      /**
       * Uncomment this to prevent from joining last month challenges
       *
       */
      this.canJoin = d.canJoin;
      this.imgUri = d.imgUri;
      this.d = d.d;
      this.loading = false;
      this.next = next;
      this.show = true;
      if (!this.imgUri || this.imgUri === '') this.getShare();
      if (!this.storyUri || this.storyUri === '') this.getShare();

      this.shareUriDisplay = `${this.$config.appUri}team-up-everyday`;
      this.shareEncoded = escape(this.shareUriDisplay);
      const shareText = 'Saya sudah #TeamUpForImpact untuk Bumi! Yuk,'
        + 'ikutan jaga bumi dengan cara yang kita bisa di ';
      this.escapedTitle = escape(shareText);
      this.waText = escape(`${shareText} ${this.shareUriDisplay}`);
    },
    close(b) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b);
    },
    getShare() {
      this.loading = true;
      this.$http.get(this.$config.uri(`challenge/item/${this.d.id}/share`)).then((r) => {
        this.loading = false;
        this.imgUri = r.data.uri;
        this.storyUri = r.data.story;
      });
    },
    recordShare() {
      this.$http.get(this.$config.uri(`challenge/item/${this.d.id}/share/record`)).then((r) => {});
    },
    openIg() {
      this.recordShare();
      this.$refs.downloadChooser.open({
        imgUri: this.imgUri,
        storyUri: this.storyUri,
      });
    },
    shareThis() {
      this.$refs.shareDialog.open();
    },
    joinNow() {
      this.loading = true;
      const userId = localStorage.getItem('_tufi_u_id') || '';
      this.$http.post(this.$config.uri(`challenge/item/${this.d.id}/sign?_u=${userId}`)).then((r) => {
        this.loading = false;
        this.d.joined = true;
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 9997;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      width: 860px;
      box-sizing: border-box;
      max-height: 80vh;
      overflow-y: auto;
      background-color: #e6e1c1;
      // background-image: url(../assets/modal-bg2.jpg);
      background-size: auto 100%;
      background-position: left;
      background-repeat: no-repeat;
      @media (max-width: 920px) {
        width: calc(100% - 40px);
      }
      @media (max-width: 760px) {
        width: calc(100% - 20px);
      }
      .tree{
        position: absolute;
        left: 0; right: -10px; bottom: 0; top: 0;
        background-image: url(../assets/FG-Kanan.svg);
        background-size: auto 120px;
        background-position: right bottom;
        background-repeat: no-repeat;
      }
      .close{
        position: absolute;
        right: 10px; top: 10px;
        background-color: rgba(0, 0, 0, .1);
        width: 32px; height: 32px;
        background-image: url(../assets/close.png);
        opacity: .65;
        background-size: 12px auto;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 50%;
        z-index: 4;
        &:hover{
          background-image: url(../assets/close-white.png);
          background-color: #5351a4;
          opacity: 1;
        }
        @media (max-width: 1480px) {
          width: 30px; height: 30px;
          background-size: 10px auto;
        }
      }
      .itemImg{
        position: absolute;
        top: 20px; left: 20px;
        width: 280px; height: 280px;
        background-color: #eee;
        background-position: center;
        background-size: cover;
        z-index: 3;
        &.loading{
          background-image: url(../assets/loading.svg);
          background-size: 46px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
        @media (max-width: 840px) {
          width: 260px; height: 260px;
        }
        @media (max-width: 680px) {
          width: 240px; height: 240px;
        }
        @media (max-width: 760px) {
          position: static;
          margin: 40px auto 20px;
        }
      }
      .itemInfo{
        padding: 26px 60px 20px 326px;
        min-height: 320px;
        box-sizing: border-box;
        position: relative;
        color: #444;
        font-size: 17px;
        line-height: 1.2;
        z-index: 3;
        @media (max-width: 840px) {
          min-height: 300px;
          padding-left: 304px;
          padding-right: 40px;
        }
        @media (max-width: 1480px) {
          font-size: 17px;
        }
        @media (max-width: 960px) {
          font-size: 16px;
        }
        @media (max-width: 760px) {
          padding: 0 20px 40px;
          display: block;
          text-align: center;
          font-size: 15px;
          line-height: 1.2;
          min-height: 0;
        }
        &.joined{
          padding-bottom: 120px;
          @media (max-width: 760px) {
            padding-bottom: 40px;
          }
        }
        .timestamp{
          text-transform: uppercase;
          font-family: 'GolosUIWebBold', sans-serif;
          font-size: 16px;
          .missionJoined{
            position: relative;
            padding-left: 28px;
            font-family: 'GolosUIWebBold', sans-serif;
            text-transform: none;
            display: inline-block;
            margin-left: 20px;
            color: #08acca;
            &:before{
              content: "";
              position: absolute;
              left: 0; top: -1px; width: 20px; height: 20px;
              background-image: url(../assets/checkmark.png);
              background-size: contain;
            }
          }
        }
        h4{
          color: #5351a4;
          font-family: 'GolosUIWebBold', sans-serif;
          font-size: 22px;
          margin: 10px 0;
          span{
            color: #f14724;
          }
        }
        button{
          margin-top: 20px;
          &.cantJoin{
            color: #767676;
            background-color: #ccc;
            border-color: #ccc;
            cursor: default;
            box-shadow: none;
          }
          @media (max-width: 680px) {
            margin-top: 10px;
          }
        }
        p{
          margin: 0;
          b{
            color: #f14724;
            font-family: 'GolosUIWebBold', sans-serif;
          }
        }
        .itemAction{
          position: absolute;
          left: 326px; bottom: 20px;
          h4{
            font-size: 15px;
            font-family: 'GolosUIWebBold', sans-serif;
            color: #767676;
            margin: 0 0 14px;
          }
          @media (max-width: 840px) {
            left: 304px;
          }
          @media (max-width: 760px) {
            position: static;
            margin-top: 20px;
          }
          .selectorCnt{
            display: flex;
            @media (max-width: 760px) {
              justify-content: space-evenly;
            }
            .selectorItem{
              margin-right: 30px;
              border-radius: 5px;
              transition: all .2s ease;
              position: relative;
              text-align: center;
              color: #444;
              cursor: pointer;
              @media (max-width: 760px) {
                margin: 0;
              }
              h4{
                margin: 0;
                font-size: 14px;
                font-weight: 600;
                color: #767676;
                font-size: 12px;
              }
              &:hover{
                opacity: 1;
                color: #5351a4;
                h4{
                  color: #5351a4;
                }
              }
              img{
                height: 30px;
                margin-bottom: 5px;
              }
            }
          }
        }
      }
    }
  }
</style>
